import EmailWalletSummaryCard from "./EmailWalletSummaryCard";
import EmailRechargePacks from "./EmailRechargePacks";
import EmailUsageTable from "./EmailUsageTable";

export default function EmailWalletPage() {

  return (
    <div style={{ padding: 116 }}>

      <h2>Email credits</h2>

      <EmailWalletSummaryCard />

      <div style={{ marginTop: 20 }}>
        <EmailRechargePacks />
      </div>

      <div style={{ marginTop: 20 }}>
        <EmailUsageTable />
      </div>

    </div>
  );
}
